import React from 'react';
import { ContactPage } from './ContactPage';

export default function Contact() {
  return <ContactPage />;
}
